import { render, staticRenderFns } from "./user_zx.vue?vue&type=template&id=bec52e0c&scoped=true"
import script from "./user_zx.vue?vue&type=script&lang=js"
export * from "./user_zx.vue?vue&type=script&lang=js"
import style0 from "./user_zx.vue?vue&type=style&index=0&id=bec52e0c&prod&scoped=true&lang=less"
import style1 from "./user_zx.vue?vue&type=style&index=1&id=bec52e0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec52e0c",
  null
  
)

export default component.exports